import { Keyword } from "@/domain/keyword";
import { classNames } from "@indietabletop/appkit";
import * as css from "./style.css";

export function UnitMiniIcons(props: { keywords: Keyword[] }) {
  const keywordsIds = new Set(props.keywords.map((k) => k.id));

  return (
    <>
      {" "}
      {keywordsIds.has("general") && <GeneralMiniIcon />}
      {keywordsIds.has("battle_standard") && <BattleStandardMiniIcon />}
      {keywordsIds.has("wizard") && <WizardMiniIcon />}
    </>
  );
}

export function KeywordMiniIcon(props: { keywordId: string }) {
  switch (props.keywordId) {
    case "general": {
      return <GeneralMiniIcon />;
    }

    case "battle_standard": {
      return <BattleStandardMiniIcon />;
    }

    case "wizard": {
      return <WizardMiniIcon />;
    }

    default: {
      return null;
    }
  }
}

export function WizardMiniIcon(props: { className?: string }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(css.miniIcon, props.className)}
    >
      <title>Wizard</title>
      <g stroke="none" fillRule="evenodd">
        <polygon
          transform="translate(8.5711, 8.2853) rotate(-315) translate(-8.5711, -8.2853)"
          points="8.57106737 10.5324912 4.32842669 12.5279221 6.32385755 8.28528137 4.32842669 4.04264069 8.57106737 6.03807155 12.8137081 4.04264069 10.8182772 8.28528137 12.8137081 12.5279221"
        />
        <polygon
          transform="translate(15.0104, 12.8246) rotate(-315) translate(-15.0104, -12.8246)"
          points="15.0104076 14.135494 12.5355339 15.2994954 13.6995352 12.8246216 12.5355339 10.3497479 15.0104076 11.5137492 17.4852814 10.3497479 16.32128 12.8246216 17.4852814 15.2994954"
        />
        <polygon
          transform="translate(4.8891, 15.3033) rotate(-315) translate(-4.8891, -15.3033)"
          points="4.8890873 16.2396383 3.12132034 17.0710678 3.95274987 15.3033009 3.12132034 13.5355339 4.8890873 14.3669634 6.65685425 13.5355339 5.82542472 15.3033009 6.65685425 17.0710678"
        />
      </g>
    </svg>
  );
}

export function BattleStandardMiniIcon(props: { className?: string }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(css.miniIcon, props.className)}
    >
      <title>Battle Standard</title>
      <g stroke="none" fillRule="evenodd">
        <path
          d="M13.6942889,8.83149789 L17,5.9159504 C16.1802912,6.03631704 15.4412094,6.06306518 14.8096305,5.98282075 L14.8096305,5.98282075 C13.8017917,5.84908004 13.1030235,5.48798012 12.3505039,5.08675799 C11.5979843,4.68553586 10.8320269,4.21744337 9.70324748,4.07032858 C9.30011198,4.0168323 8.41321389,3.94996195 7.79507279,4.05695451 C7.17693169,4.16394708 6.92161254,4.23081744 6.41097424,4.4314285 L6.30347144,4.47155072 L6.30347144,4.57854329 C6.20940649,5.48798012 5.76595745,9.07223117 5.44344905,11.9476565 C5.2150056,13.8601486 5,15.4650372 5,15.7325186 L5,15.8662593 L5,15.8662593 L6.1556551,16 L6.29003359,16 L6.29003359,16 L6.29003359,16 L6.33034714,15.8395111 C6.37066069,15.6522742 6.39753639,15.3446705 6.46472564,14.9568225 C6.57222844,14.0875078 6.76035834,12.6698563 7.02911534,10.3962642 C8.19820829,10.2224013 9.60918253,10.9579752 10.4154535,11.3993195 C11.2217245,11.8406639 12.0414334,12.2686342 13.2777156,12.4424971 L13.2777156,12.4424971 C14.0974244,12.5494897 14.9171333,12.5628637 16.0593505,12.4157489 L13.6942889,8.83149789 Z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export function GeneralMiniIcon(props: { className?: string }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(css.miniIcon, props.className)}
    >
      <title>Army General</title>
      <g stroke="none" fillRule="evenodd">
        <polygon points="10 13.726237 5.88550323 15.663119 6.45613804 11.1514706 3.34260439 7.83688104 7.80977286 6.98541096 10 3 12.1902271 6.98541096 16.6573956 7.83688104 13.543862 11.1514706 14.1144968 15.663119" />
      </g>
    </svg>
  );
}
